import { ApiService } from "./api.service";
export default class TypeService extends ApiService {
  namespace = "export-data";
  icon = "BlueCube";
  name = "Type";
  favicon = "Export";

  Width = 690;

  constructor() {
    super("export");
  }
}
